exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/globalNotification/globalNotification.styl
// module id = 432
// module chunks = 0